export default "__VITE_ASSET__CxCW95y0__"